import React from 'react';

import { Link } from 'components/elems';
import { UserSignupForm } from 'components/forms';


// <div className="moa-ff-sans f5 black-50 mt4 lh-copy">
//   RSS for humans
//   <span
//     style={{color: MOA_COLOR.stories.brinkPink}}
//     className="mh2"
//   >—</span>
//   <br/>
//   In more than 140 characters
// </div>


// TODO: Header opacity, rhs icon, footer position in small screen..

const PunchyCopyAboveSignupForm = () => (
  <div className="tc">
    <div className="moa-ff-argent near-black f1 fw4">
      Moagraph
    </div>
    <div className="moa-ff-sans f4 black-70 mv4 pb3 b">
      Sign up today.
    </div>
  </div>
);

const StuffBelowSignupForm = () => (
  <div className="black-50 f6 mt4 tr">
    <span className="mr2">
      Have an account?
    </span>
    <Link type="accented" to="/login">Log in</Link>
  </div>
);


const Signup = () => (
  <div className="moa-ff-sans min-vh-100 pt5 ph3 ph5-ns mw6 center">
    <div className="mt3 pt5">
      <UserSignupForm
        copyAboveSignupForm={<PunchyCopyAboveSignupForm />}
        stuffBelowSignupForm={<StuffBelowSignupForm />}
      />
    </div>
  </div>
);

export default Signup;



// WEBPACK FOOTER //
// ./src/pages/Signup.js